import { useParams } from 'react-router';
import { useTranslation } from 'react-i18next';
import { en, type CatalogueKey } from '@mahallu/shared';
import { PageHeader } from '../components/Parts';

/** Placeholder for screens designed in the prototype but not built yet. */
export function NotBuilt() {
  const { t } = useTranslation();
  const { key = '' } = useParams();
  const candidate = `nav.${key.replace(/-/g, '.')}`;
  const title = candidate in en ? t(candidate as CatalogueKey) : t('soon.title');
  return <PageHeader icon="file" title={title} desc={`${t('soon.title')}. ${t('soon.body')}`} />;
}
